<template>
  <div class="main-wrapper">
    <p>Ваша заявка получена Банком. После проверки предоставленных Вами данных оператор свяжется с вами!</p>
  </div>
</template>

<script>
export default {
  name: "LastName",
props: {
 pageInfo: {},mainInfo: {},
    url: String
  },
};
</script>

<style scoped>
</style>